export const MIN_SUB_ROWS_VISIBLE_ON_EXPAND = 3;
export const AUTO_SCROLL_BOTTOM_PADDING = 8;
